import { ShoppingCart } from "lucide-react";
import { Button } from "@design-lab/shared/ui";

interface AddToCartTransfersProps {
  onAddToCart: () => void;
  isLoading?: boolean;
  isDisabled?: boolean;
}

export function AddToCartTransfers({
  onAddToCart,
  isLoading = false,
  isDisabled = false
}: AddToCartTransfersProps) {
  return (
    <Button
      data-testid="add-to-cart-transfers-button"
      onPress={onAddToCart}
      variant="destructive"
      size="3xl"
      isDisabled={isDisabled}
      className={`h-16 min-w-48 ${isDisabled ? "opacity-30" : ""}`}
    >
      <ShoppingCart className="size-6" />
      {isLoading ? "ADDING..." : "ADD TO CART"}
    </Button>
  );
}
